import React, { useState } from 'react'; // NEW: Import useState
import { VolumeDiscount } from '../types/costwand.d';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table.tsx';
import { Button } from './ui/button.tsx';
import Pagination from './ui/Pagination.tsx';
import { Spinner } from './ui/spinner.tsx'; // Import Spinner
import { apiClient } from '../api/apiClient.ts'; // NEW: Import apiClient

interface VolumeDiscountTableProps {
  volumeDiscounts: VolumeDiscount[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onEdit: (volumeDiscount: VolumeDiscount) => void;
  onDelete: (id: number) => void;
  loading: boolean;
  error: string | null;
  baseEndpoint: string; // NEW: Add baseEndpoint prop
}

const VolumeDiscountTable: React.FC<VolumeDiscountTableProps> = ({
  volumeDiscounts,
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  onEdit,
  onDelete,
  loading,
  error,
  baseEndpoint, // NEW: Destructure baseEndpoint
}) => {
  const [exportLoading, setExportLoading] = useState(false); // NEW: State for export loading

  const handleExportCsv = async () => {
    setExportLoading(true);
    try {
      await apiClient<void>(baseEndpoint, { downloadCsv: true });
    } catch (err: any) {
      // Error already handled by apiClient and globalErrorHandler
    } finally {
      setExportLoading(false);
    }
  };

  if (loading) return <p className="text-center text-muted-foreground flex items-center justify-center gap-2"><Spinner size="sm" /> Loading Volume Discounts...</p>;
  if (error) return <p className="text-center text-destructive">Error: {error}</p>;
  if (volumeDiscounts.length === 0 && !loading) return <p className="text-center text-muted-foreground">No Volume Discounts found.</p>;

  return (
    <div className="rounded-md border">
      <div className="flex justify-end mb-4"> {/* NEW: Wrapper for export button */}
        <Button onClick={handleExportCsv} disabled={loading || exportLoading} variant="outline">
          {exportLoading ? <span className="flex items-center gap-2"><Spinner size="sm" /> Exporting...</span> : 'Export to CSV'}
        </Button>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Product</TableHead>
            <TableHead>Min Quantity</TableHead>
            <TableHead>Price Retained %</TableHead>
            <TableHead>Discount %</TableHead> {/* Added Discount % column */}
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {volumeDiscounts.map((discount) => {
            // Calculate the discount percentage for better readability
            const discountPercentage = 100 - discount.price_retained_perc;
            return (
              <TableRow key={discount.id}>
                <TableCell className="font-medium">
                  {discount._labels?.product_id || `Product ID: ${discount.product_id}`}
                </TableCell>
                <TableCell>{discount.min_quantity}</TableCell>
                <TableCell>{discount.price_retained_perc}%</TableCell>
                <TableCell>{discountPercentage.toFixed(2)}%</TableCell> {/* Display calculated discount */}
                <TableCell className="flex justify-end gap-2">
                  <Button variant="outline" size="sm" onClick={() => onEdit(discount)}>Edit</Button>
                  <Button variant="destructive" size="sm" onClick={() => onDelete(discount.id)}>Delete</Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default VolumeDiscountTable;